import { TaskType } from 'src/common/enums/task';

export const DOWNLOADABLE_ICON_TOOLTIP_MESSAGE = 'Task includes a downloadable file';
export const STATIC_WEBSITE_ICON_TOOLTIP_MESSAGE = 'Task includes website';
export const DEPLOYABLE_MACHINE_ICON_TOOLTIP_MESSAGE = 'Task includes a deployable machine';
export const CLOUD_DETAILS_ICON_TOOLTIP_MESSAGE = 'Task includes cloud details';

export const DOWNLOADABLE_BUTTON_MESSAGE = 'Download Task Files';
export const STATIC_WEBSITE_BUTTON_MESSAGE = 'View Site';
export const DEPLOYABLE_MACHINE_BUTTON_MESSAGE = 'Start Machine';
export const CLOUD_DETAILS_MESSAGE = 'Cloud Details';

export const ACCORDION_ANIMATION_DURATION = 600;

export const TASK_TYPES_WITH_VM = [TaskType.VM, TaskType.THM];
